<template>
  <div>
    <div class="r-tabs-accordion-title r-tabs-state-active"><a href="#tab-1" class="r-tabs-anchor" v-translate>Vlastnosti</a></div>
    <div class="tabs_content r-tabs-panel r-tabs-state-active" id="tab-1" style="display: block;">

      <section>
        <div class="left">
          <detail-entity-info
              :entity="entity"
              :title="$gettext('Základní údaje')"
          />
        </div>

        <div class="right">

          <div class="field_left">
            <text-input
                id="name"
                :required="true"
                :disabled="!isEditable"
                v-model="entity.name"
                ref="nameref"
            >
              <translate class="translate">Název</translate>
            </text-input>
          </div>

          <div class="field_right">
            <text-input
                id="code"
                :required="true"
                v-model="entity.code"
                ref="coderef"
                :disabled="!isEditable"
            >
              <translate class="translate">Kód</translate>
            </text-input>
          </div>

          <div class="field_left">
            <select-box
                id="module_type"
                :options="moduleTypes"
                v-model="entity.module_type"
                :required="true"
                ref="moduletyperef"
                :disabled="!isEditable"
            >
              <translate class="translate">Typ modulu</translate>
            </select-box>
          </div>

          <p class="field">
            <JSONTextareaInput
                v-model="entity.authentication_data"
                rows="10"
                :disabled="!isEditable"
            >
              <translate class="translate">Autentizační data</translate>
            </JSONTextareaInput>
          </p>

        </div>

      </section>

      <section class="buttons">
        <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam</router-link>
        <input
            v-if="$_updateActionAllowed"
            type="submit"
            :value="'Uložit' | translate"
            class="btn"
            @click.prevent.stop="$emit('saveEntity')">
      </section>
    </div>
  </div>
</template>

<script>

import JSONTextareaInput from "../../../common/JSONTextareaInput.vue";
import DetailEntityInfo from "../../../common/DetailEntityInfo.vue";

export default {
  name: 'AdvertisingProviderSettings',
  components: { DetailEntityInfo, JSONTextareaInput },
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  data() {
    return {
      moduleName: 'advertisingProviders',
      moduleTypes: [
        {id: 'grdb', text: 'GRDB'},
        {id: 'rap', text: 'RAP'},
      ],
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/advertisingProviders/detail/Settings.vue